// App-specific localStorage keys managed by Axaris (user profile + RBAC mirrors + org context).
// The session credential is an HttpOnly cookie, never in JS — nothing token-like is stored here.
// `accessToken` is retained in the clear list only to purge any stale value from before the
// cookie-based (BFF) migration.
const APP_STORAGE_KEYS = [
  "accessToken",
  "user",
  "userRoles",
  "orgHierarchy",
  "dealHierarchy",
  "businessUnitHierarchy",
  "isSuperAdmin",
  "isSupportAdmin",
  "selectedOrganization",
  "selectedTenantId",
];

/**
 * Remove Axaris app keys from localStorage (e.g. on logout or an auth reset).
 */
export function clearAppStorage() {
  APP_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
